import { useState } from 'react';
import Dialog from '../../../organisms/Dialog';

interface Props {
    isOpen: boolean;
    compositionLabel: string;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: (reason: string) => void;
}

const CompositionDeactivateModal = ({ isOpen, compositionLabel, loading = false, onCancel, onConfirm }: Props) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const confirm = () => {
        if (!reason.trim()) {
            setError('Informe o motivo da desativação.');
            return;
        }
        onConfirm(reason.trim());
        setReason('');
        setError('');
    };

    const cancel = () => {
        if (loading) return;
        setReason('');
        setError('');
        onCancel();
    };

    return (
        <Dialog
            id="composition-deactivate"
            show={isOpen}
            onClose={cancel}
            size="sm"
            header={`Desativar ${compositionLabel}`}
            body={
                <div className="p-4 space-y-4">
                    <p className="text-sm text-gray-600 dark:text-gray-300">
                        Enquanto desativada, a composição não gera notificações. Você poderá reativá-la a qualquer
                        momento, então esta ação é reversível.
                    </p>
                    <div>
                        <label className="block text-sm text-gray-600 dark:text-gray-300 mb-1">
                            Motivo da desativação <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            className="w-full border border-gray-300 dark:border-slate-600 rounded-md p-2 text-sm dark:bg-slate-900 dark:text-gray-100"
                            rows={4}
                            value={reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                if (error) setError('');
                            }}
                            placeholder="Explique por que está desativando. Esse registro ajuda quem for reativar no futuro."
                            disabled={loading}
                        />
                        {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
                    </div>
                </div>
            }
            footer={
                <div className="flex gap-3">
                    <button
                        onClick={cancel}
                        disabled={loading}
                        className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 rounded-lg disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={confirm}
                        disabled={loading || !reason.trim()}
                        className="px-4 py-2 text-sm text-white bg-red-600 hover:bg-red-700 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Desativando...' : 'Desativar'}
                    </button>
                </div>
            }
        />
    );
};

export default CompositionDeactivateModal;
